import { useCallback } from 'react';
import type { RequestOpts } from '@oazapfts/runtime';

import { appConfig } from '@/config';
import { useAuth } from '@/hooks/use-auth';
import { useMe } from '@/hooks/use-me';

export function useFetchOpts(): () => Promise<RequestOpts> {
  const me = useMe();
  const auth = useAuth();

  return useCallback(
    async function () {
      const accessToken = await auth.getAccessToken();

      return {
        baseUrl: `${appConfig.bffUrl}/plex`,
        headers: {
          authorization: `Bearer ${accessToken}`,
          'x-user-email': me.email,
          'x-user-name': me.displayName,
        },
      };
    },
    [auth, me.email, me.displayName],
  );
}
